<template>
  <el-dropdown
    trigger="click"
    placement="bottom-start"
    v-if="ig_info.length > 0"
  >
    <div class="ig-selected-wrap pointer" v-if="ig_selected != ''">
      <el-image
        :src="
          s3BaseUrl + '/profile_picture/' +
          ig_selected.account_name +
          '.jpg'
        "
        class="ig-selected-profile"
      >
        <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
      </el-image>
      {{ ig_selected.account_name }}
      <div class="ig-selected-unseen" v-if="unseen > 0 && referer == 'message'">
        {{ unseen }}
      </div>
      <span
        class="ig-selected-login-required"
        v-if="ig_selected.login_required"
      >
        <font-awesome-icon
          :icon="['fas', 'exclamation-circle']"
          style="color: #f56c6c"
        />
        連携が解除されています</span
      >
      
      <span
        class="ig-selected-login-required"
        v-if="hasApiError"
      >
        <font-awesome-icon
          :icon="['fas', 'exclamation-circle']"
          style="color: #f56c6c"
        />
        通信エラー</span
      >
      
      <font-awesome-icon
        :icon="['fas', 'caret-down']"
        style="margin-left: 15px"
      />
      <!-- <div v-if="ig_info.profile_picture_url == ''" class="list-member-noimg assign">{{ ig_info.account_name | firstLetter }}</div> -->
    </div>
    <div class="data-table-list-status-button pointer" v-else>
      アカウントを選択
      <font-awesome-icon
        :icon="['fas', 'caret-down']"
        style="margin-left: 10px"
      />
    </div>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        style="font-size: 12px"
        :disabled="isButtonDisabled"
        v-for="ig_info in ig_info"
        :key="ig_info.id"
        class="member"
        @click.native="
          ig_info.account_name == ig_selected.account_name
            ? ''
            : changeIGAccount(ig_info)
        "
      >
        <el-image
          :src="
            s3BaseUrl + '/profile_picture/' +
            ig_info.account_name +
            '.jpg'
          "
          class="list-member-profile dropdown"
          v-if="ig_info.profile_picture_url != ''"
        >
          <div slot="error" class="data-table-profile-noimg">NO<br />IMAGE</div>
        </el-image>
        <div class="list-member-noimg dropdown" v-else>
          {{ ig_info.account_name | firstLetter }}
        </div>
        <div class="list-member-dropdown-namearea">
          <div>{{ ig_info.account_name }}</div>
          <div v-if="ig_info.account_name == ig_selected.account_name">
            <div class="pointer times-circle">
              <font-awesome-icon
                icon="check-circle"
                style="color: #0095f6; font-size: 14px"
              />
            </div>
          </div>
        </div>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
  <div v-else>メッセージ</div>
</template>

<script>
const root = process.env.VUE_APP_API;
const checkAPI = root + "/api/message/check";

export default {
  name: "connectAccount",
  props: ["name", "referer"],
  data() {
    return {
      unseen_count: 0,
      isButtonDisabled: false,
      hasApiError: false,
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user_token() {
      return this.$store.state.user_token;
    },
    ig_info() {
      return this.$store.state.ig_info;
    },
    ig_selected() {
      return this.$store.state.ig_selected;
    },
    account_name() {
      return this.$store.state.ig_selected.account_name;
    },
    unseen() {
      return this.$store.state.ig_selected.unseen_count;
    },
  },
  mounted() {
    if (this.ig_selected != "") {
      this.loginCheck(true);
    } else {
      this.unseen_count = this.ig_selected.unseen_count;
    }
  },
  methods: {
    changeIGAccount(value) {
      this.$store.dispatch("changeIGAccount", value);
    },
    isIgAccountLoading(value, loaded) {
      this.$emit('isIgAccountLoading', value, loaded);
    },
    loginCheck(isCallMounted = false) {
      this.hasApiError = false;
      if (isCallMounted && this.referer === 'message') {
        /**
         * mounted時かつダイレクトメッセージメニュー経由でマウントされた場合は「src/components/message/inbox.vue」の「loadInbox」メソッドで
         * ログインチェックと未読数取得が完了しているので本メソッドを実行しない。
         * 仮に実行してしまった場合は以降の処理のAPIレスポンスがfailになった場合、未読数が「0」に上書きされてしまい表示に差異が発生するため
         * 該当チケット：https://dohouse.backlog.jp/view/REECH-1444
         */
        return;
      }
      this.isButtonDisabled = true;
      this.isIgAccountLoading(this.isButtonDisabled, true);

      var params = new URLSearchParams();
      params.append("token", this.token);
      params.append("account_name", this.ig_selected.account_name);
      this.axios
        .post(checkAPI, params)
        .then((response) => {
          if (!response || response.data.status !== "OK") {
            throw new Error("API response 異常");
          }
          // ユーザ情報はDB上のデータとvuexデータのずれが発生するケースがあるため都度更新
          return this.$store
            .dispatch("getUserData", {
              token: this.token,
              user_token: this.user_token,
            })
            .then(() => {
              // 成功時のみデータ更新
              if (response.data.status === "OK") {
                
                // アカウント情報を取得できた場合は更新
                if(response.data.ig_selected) {
                  this.$store.dispatch("changeIGAccount",response.data.ig_selected);  
                }
                
                // inboxの未読数を取得
                const inbox = response?.data?.res?.inbox;
                const unseenCount = inbox && typeof inbox.unseen_count === 'number' ? inbox.unseen_count : null;

                // 未読数が取得できた場合は更新、取得できなければ0をセット
                if (unseenCount !== null) {
                  this.$store.dispatch("IGAccountUpdate", unseenCount);
                  this.unseen_count = unseenCount;
                } else {
                  this.unseen_count = 0;
                }
                              
                this.isButtonDisabled = false;
                this.isIgAccountLoading(this.isButtonDisabled, false);
                this.hasApiError = false;
              } else {
                // 疎通エラーの場合はアカウント選択のみアクティブに戻す
                this.isButtonDisabled = false;
                this.hasApiError = true;
                this.isIgAccountLoading(this.hasApiError, false);
              }
            });
        })
        .catch((error) => {
          // エラー情報を親コンポーネントへ伝播させる
          this.$emit('error-message-check', error.message);
          // 疎通エラーの場合はアカウント選択のみアクティブに戻す
          this.isButtonDisabled = false;
          this.isIgAccountLoading(true, false);
        });
    },
  },
  watch: {
    account_name() {
      this.loginCheck();
      // this.$emit('userThread')
    },
    // ig_selected: {
    //   handler() {
    //     this.$set(this.unseen_count, this.ig_selected.unseen_count);
    //   },
    //   deep: true,
    // },
  },
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>

<style></style>
